import {Component, inject, OnInit, viewChild} from '@angular/core';
import {DataService} from "../../services/data.service";
import {DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {AdminNavigationComponent} from "../admin-navigation/admin-navigation.component";
import {FileUploadModule} from "ng2-file-upload";
import {ModalDirective} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-admin-codes',
    imports: [
        FormsModule,
        NgForOf,
        NgIf,
        AdminNavigationComponent,
        FileUploadModule,
        ModalDirective
    ],
  templateUrl: './admin-codes.component.html',
  styleUrl: './admin-codes.component.scss'
})
export class AdminCodesComponent implements OnInit {

    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);

    codeModal = viewChild.required<ModalDirective>('codeModal');

    slug!: string|null|undefined;
    codes: any[] = [];
    assignedCodes = 0;
    openedCode: any|null = null;

    ngOnInit(): void {
        this.slug = this.route.parent?.snapshot.paramMap.get('slug');

        this.dataService.request("Code/listAll").subscribe(response => {
            this.codes = response.codes;

            this.assignedCodes = this.codes.filter(code => code.assigned == '1').length;
        })
    }

    selectCode(code: any) {
        this.openedCode = code;

        this.codeModal().show();
    }

    closeCode() {
        this.openedCode = null;
        this.codeModal().hide();
    }

    updateCode(): void {
        this.dataService.request("Code/update", {
            code: this.openedCode
        }).subscribe(response => {
            this.closeCode();
        })
    }
}
